import React, { CSSProperties, useContext } from "react";
import Timeline from "features/trades/TradeDrawer/Timeline/Timeline";
import Flex from "common/Boxes/Flex";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { TradeDetailsContext } from "@shared/features/trades/TradeDetails.context";
import useMedia from "utils/hooks/useMedia";
import { MAX_DRAWER_EXTENSION_SCREEN } from "common/constants";
import TradeChart from "features/trades/TradeDrawer/TradeChart";

interface TimelinePageProps {
  style?: CSSProperties;
}

const TimelinePage = ({ style }: TimelinePageProps) => {
  const { getTradeExtraInfoActivitiesStatus, getTradeExtraInfoOrdersStatus } =
    useContext(TradeDetailsContext)!;
  const isSmallScreen = useMedia(
    [`(max-width: ${MAX_DRAWER_EXTENSION_SCREEN})`],
    [true],
    false
  );

  if (
    !getTradeExtraInfoActivitiesStatus.currentData ||
    !getTradeExtraInfoOrdersStatus.currentData
  ) {
    return (
      <LoadingSpinnerOverlay
        isLoading={true}
        hideContentWhileLoading={true}
        spinnerSize="large"
      />
    );
  }

  return (
    <Flex
      $flexDirection="column"
      $alignItems="center"
      style={{ height: "100%", ...style }}
    >
      {isSmallScreen && <TradeChart />}
      <Timeline />
    </Flex>
  );
};

export default TimelinePage;
